module.exports = __webpack_public_path__ + "img/tegeltje.10253a0c.png";